import axios from "axios";

const IDENTITY_URL = process.env.REACT_APP_IDENTITY_URL || "http://localhost:8081/api/v1/identity";

/**
 * Look up a user's region by email.
 * Returns { region, apiBaseUrl } or null if not found.
 */
export const lookupByEmail = async (email) => {
  try {
    const response = await axios.get(`${IDENTITY_URL}/lookup`, {
      params: { email },
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};

/**
 * Submit organization signup to the identity service.
 */
export const registerOrganization = async (data) => {
  const response = await axios.post(`${IDENTITY_URL}/organizations`, data);
  return response.data;
};

/**
 * Call the real regional login endpoint.
 */
export const regionalLogin = async (apiBaseUrl, credentials) => {
  const response = await axios.post(`${apiBaseUrl}/auth/login`, credentials, {
    withCredentials: true,
  });
  return response.data;
};
